module.exports = __webpack_public_path__ + "static/img/step-2.3b9ca99.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/tuto-unlock-popup/firefox/step-2.png
// module id = BJJX
// module chunks = 1